import { Stack } from '@razz-team/ui-web';
import {
  useThreeDSCodeSuspenseQuery,
  useUnauthenticated3dsResolveMutation,
} from '../../../api/3ds';
import { Route } from '../../../routes/3ds.$code';
import { ThreeDSStatus } from './ThreeDSStatus';
import { ThreeDSDetails } from './ThreeDSDetails';
import { ThreeDSActions } from './ThreeDSActions';

export function ThreeDSPage() {
  const { code } = Route.useParams();
  const query = useThreeDSCodeSuspenseQuery({ code });
  const mutation = useUnauthenticated3dsResolveMutation({ code });

  return (
    <Stack spacing={4} width="100%" alignItems="center">
      <ThreeDSStatus threeDS={query.data} />
      <ThreeDSDetails threeDS={query.data} />
      <ThreeDSActions threeDS={query.data} mutation={mutation} />
    </Stack>
  );
}
